// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowURight16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-u-right': IconArrowURight;
    }
}

/**
 * The icon component for the 'arrowURight' icon
 */
export class IconArrowURight extends IconSvg {
    public constructor() {
        super(arrowURight16X16);
    }
}

registerIconSvg('icon-arrow-u-right', IconArrowURight);
export const iconArrowURightTag = 'nimble-icon-arrow-u-right';
